module.exports = __webpack_public_path__ + "img/mainSlope-nav.3c00d0e7.svg";